import React from 'react';
import { useNavigate } from 'react-router-dom';

import { QRStyled } from './styled';

import clsx from 'clsx';
import { child, get, onValue, ref, set, update } from 'firebase/database';
import database from 'src/libraries/firebase';

interface QRProps {
  className?: string;
}

const qrcode = (window as any).qrcode;

const QR = ({ className }: QRProps) => {
  const [scanning, setScanning] = React.useState(false);
  const [stream, setStream] = React.useState<any>(null);
  const videoRef = React.useRef<HTMLVideoElement>(null);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    const { current: canvasCurrent } = canvasRef;
    const { current: videoCurrent } = videoRef;

    if (canvasCurrent && videoCurrent && !scanning) {
      const context2D = canvasCurrent.getContext('2d');

      qrcode.callback = async (res: unknown) => {
        if (res) {
          try {
          } catch (error) {
            console.error(error);
          }
          const robotSettingRef = ref(database, 'health_robot/setting/status');
          const snapshot = await get(robotSettingRef);
          const robotStatus = snapshot.val();

          if (robotStatus === 'PENDING') {
            await set(robotSettingRef, 'START');
            (videoCurrent as any).srcObject
              .getTracks()
              .forEach((track: any) => {
                track.stop();
              });

            localStorage.setItem('timer', `${new Date().getTime()}`);
            navigate('/motion');
          } else {
            alert(`robot status not ready! current: ${robotStatus}`);
          }
        }
      };

      window.navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'environment' } })
        .then(function (stream) {
          setScanning(true);
          setStream(stream);
          videoCurrent.srcObject = stream;
          videoCurrent.play();

          (function tick() {
            let videoRatio = 0;
            if (videoCurrent.videoWidth > 0) {
              videoRatio = videoCurrent.videoHeight / videoCurrent.videoWidth;
            }
            canvasCurrent.width = window.innerWidth;
            canvasCurrent.height = window.innerWidth * videoRatio;

            if (context2D) {
              context2D.drawImage(
                videoCurrent,
                0,
                0,
                canvasCurrent.width,
                canvasCurrent.height,
              );
            }
            requestAnimationFrame(tick);
          })();

          (function scan() {
            try {
              qrcode.decode();
            } catch (e) {
              setTimeout(scan, 300);
            }
          })();
        });
    }
  }, [videoRef.current]);

  React.useEffect(() => {
    return () => {
      console.log(stream);
      if (stream) {
        (stream as any).getTracks().forEach((track: any) => {
          track.stop();
        });
      }
    };
  }, []);

  return (
    <QRStyled className={clsx('QR', className)}>
      <video
        ref={videoRef}
        style={{
          position: 'absolute',
          display: 'none',
        }}
      ></video>
      <canvas id="qr-canvas" ref={canvasRef}></canvas>
    </QRStyled>
  );
};

export default QR;
